export default "__VITE_ASSET__DGltkHio__"